import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { LayoutDashboard, BookOpen, Mail, ClipboardList, Clock, 
  CircleCheck,  History, Target, Users, ShieldCheck} from 'lucide-react';

export const Sidebar = ({ onActiveItemChange }) => {
  const [activeItem, setActiveItem] = useState('Course List');
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    { name: 'Course List', icon: BookOpen, path: '/admin/courseslist' },
    { name: 'Course Users', icon: Users, path: '/courseusers' },
    { name: 'Course Access', icon: ShieldCheck, path: '/courseaccess' },
    { name: 'News Letter', icon: Mail, path: '/newsletter' },
    { name: 'Services Summary', icon: ClipboardList, path: '/service' },
    { name: 'Webinar', icon: Clock, path: '/webinar' },
     { name: 'Webinar Registration', icon: ClipboardList, path: '/webinarregistration' },
    { name: 'Completed Service', icon: CircleCheck, path: '/completedservice' },
    { name: 'Course Payment history', icon: History, path: '/paymenthistory' },
     { name: 'Webinar Payment history', icon: History, path: '/webinarpaymenthistory' },
     { name: 'Mission', icon: Target, path: '/missionadmin' },
  ];

  
  useEffect(() => {
    const currentPath = location.pathname;
    const activeMenuItem = menuItems.find(item => item.path === currentPath);
    if (activeMenuItem) {
      setActiveItem(activeMenuItem.name);
      if (onActiveItemChange) {
        onActiveItemChange(activeMenuItem.name);
      }
    }
  }, [location.pathname, onActiveItemChange]);

  const handleNavigation = (item) => {
    setActiveItem(item.name);
    if (onActiveItemChange) {
      onActiveItemChange(item.name);
    }
    navigate(item.path);
  };

  return (
    <div
      style={{ width: 280 }}
      className="h-screen bg-white border-r border-slate-100 flex flex-col sticky top-0 left-0 z-40"
    >
      <nav className="flex-1 px-4 space-y-2 overflow-y-auto custom-scrollbar pt-4">
        {menuItems?.map((item) => {
          const Icon = item.icon;
          const isActive = activeItem === item.name;
          
          return (
            <button
              key={item.name}
              onClick={() => handleNavigation(item)}
              className={`cursor-pointer w-full flex items-center text-sm gap-3 px-4 py-3 rounded-xl transition-all duration-200 group
                ${isActive 
                  ? 'bg-gradient-to-r from-amber-500 to-orange-500 text-white' 
                  : 'text-slate-600 hover:bg-orange-50 hover:text-orange-600'
                }`}
            >
              <Icon size={22} className={isActive ? 'text-white' : 'text-slate-400 group-hover:text-orange-500'} />
              
              <span className="font-medium whitespace-nowrap">
                {item.name}
              </span>
            </button>
          );
        })}
      </nav>
    </div>
  );
};